<template>
  <b-container>
    <h1>Admin Dashboard</h1>

    <users-table :count="7" title />
    <meetings-table :count="7" title />
    <reviews-table :count="7" title />
    <educational-items-table :count="7" title />
  </b-container>
</template>

<script>
import UsersTable from '@/components/admin/UsersTable'
import MeetingsTable from '@/components/admin/MeetingsTable'
import ReviewsTable from '@/components/admin/ReviewsTable'
import EducationalItemsTable from '@/components/admin/EducationalItemsTable'

export default {
  name: 'Dashboard',
  components: {
    UsersTable,
    MeetingsTable,
    ReviewsTable,
    EducationalItemsTable
  }
}
</script>
